import useNavigateWithQuery from 'hooks/useNavigateWithQuery';
import { Externalautomation } from 'data/firestore/agent/externalautomation/types';
import { EntityGet } from 'data/firestore/types';
import { CellWrapper, StyledA } from './styled';

interface Props {
    row?: EntityGet<Externalautomation>;
}

const NameColumn = ({ row }: Props) => {
    const navigateWithQuery = useNavigateWithQuery();

    if (!row) return null;

    return (
        <CellWrapper>
            <StyledA onClick={() => navigateWithQuery(`${row.id}`)}>{row.name}</StyledA>
        </CellWrapper>
    );
};

export default NameColumn;
